import { render, staticRenderFns } from "./ProductPricingReport.vue?vue&type=template&id=77cd53d2"
import script from "./ProductPricingReport.vue?vue&type=script&lang=js"
export * from "./ProductPricingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports